function filterToggle() {
 if ($(window).width() > 749 && $(window).width() < 990) {
	$(".product-grid-container").addClass("added");
	//$(".facets-wrapper").addClass("open");
  }
  $(".facets-vertical-form .filter-btn").click(function(){
  	$(".product-grid-container").toggleClass("added");
  	$(".facets-wrapper").toggleClass("open");
  });
}

filterToggle();